import React from "react";
import { useI18n } from "Hooks";
import classes from "./ChooseComponent.scss";
import { ToddleIcon } from "SvgComponents";

const ChooseComponent = ({ setScreenWithRole }) => {
  const { t } = useI18n(["signin", "common"]);

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={classes.toddleIcon}>
          <ToddleIcon />
        </div>
      </div>

      <div className={classes.title}>{t("signin:choose_role")}</div>

      <div className={classes.tabsContainer}>
        <div
          className={classes.tabs}
          onClick={() => setScreenWithRole("todden")}
        >
          {t("common:teacher")}
        </div>
        <div
          className={classes.tabs}
          onClick={() => setScreenWithRole("administrator")}
        >
          {t("common:admin")}
        </div>
      </div>
    </div>
  );
};

export default ChooseComponent;
